goog.module('yext.admin.employeeauthenticator.init');
goog.module.declareLegacyNamespace();

$(document).ready(function() {
  // copy-pasted from ancient templates
  var u = document.getElementById('username');
  var p = document.getElementById('password');
  if (u.value == '') {
    u.focus();
  } else if (p.value == '') {
    p.focus();
  }
});

